export const getMiles = (meters: number) => {
  const miles = meters * 0.000621371192
  return Math.round(miles * 10) / 10
}
